import { PartnerIcon } from "./icons";
import StatusWrapper from "./status-wrapper";

function Content() {
  return (
    <p className="font-normal text-14/[1.71em] text-heather">
      This venue is a Morty Partner.
      <br />
      <br />
      Partners enjoy benefits including boosted visibility and instant bookings,
      while supporting Morty’s mission.{" "}
      <a className="text-rose-red" href="/s/morty-partner-program">
        Learn more.
      </a>
    </p>
  );
}

export default function Partner(props: React.ComponentProps<"svg">) {
  return (
    <StatusWrapper
      content={<Content />}
      popoverProps={{
        align: "start",
        className:
          "bg-[url(/images/partner-popover-bg.png)] bg-center bg-no-repeat bg-size-[90%]",
        side: "top",
      }}
      title={
        <>
          <PartnerIcon className="mr-2.5 size-4.5" /> Morty Partner
        </>
      }
    >
      <div className="inline-flex items-center">
        <PartnerIcon {...props} />
      </div>
    </StatusWrapper>
  );
}
